<!-- 
    What do you want to see?
    Their write up, their DP.

    Maybe the post they've written - and interacted with??
    Their project.

    Maybe their serving state?? Only their serving state. If they hold any public post.

    design inspiration - https://static.collectui.com/shots/3951507/team-member-profile-projects-large

    Why would we ever need to show their social media links??

    best loader idea: https://flowbite.com/docs/components/skeleton/
    Please+++God
 -->
<div class="flex-col-reverse flex md:flex-col h-full">

  <app-nav></app-nav>

  <div class="flex-1 p-2 md:p-4 flex items-center justify-center">
    <section class="max-h-[calc(100dvh-64px-16px)] flex-col md:flex-row flex gap-2 w-fit  items-center md:items-start justify-center">
      <mat-card class="h-fit max-h-96 " *ngIf="corpMember?.Media?.url">
        <img
          mat-card-image
          [src]="corpMember?.Media?.url"
          alt="Profile Photo"
          class="object-cover md:max-w-72 h-auto"
        />
      </mat-card>
  
      <mat-card
        class="flex-1 overflow-auto md:max-h-[calc(100dvh-64px-16px)] w-full"
        [ngClass]="{ 'animate-pulse bg-gray-200': isLoading, 'justify-between': !corpMember?.bio }"
      >
        <mat-card-header>
          <mat-card-title *ngIf="corpMember?._fullname">{{ corpMember?._fullname }}</mat-card-title>
          <mat-card-subtitle>Joined {{ corpMember?.time_with_us }}</mat-card-subtitle>
          <mat-card-subtitle>
            <mat-icon inline class="align-bottom" aria-label="Location icon">location_on</mat-icon>
            <span>{{ corpMember?._location }}</span>
          </mat-card-subtitle>
        </mat-card-header>
  
        <mat-card-content class="overflow-scroll">
          {{ corpMember?.bio ?? 'No bio.' }}
        </mat-card-content>
  
        <mat-card-actions class="!hidden" align="end" *ngIf="callerService.isLoggedIn">
          <!-- @todo: show when we implement chat functionality -->
          <button type="button" mat-button>Send message</button>
        </mat-card-actions>
      </mat-card>
  
    </section>
  </div>
</div>
